import React, { useEffect, useRef, useState } from 'react'

import { mortgageIframe, mortgageWidgetClass } from './styles.css'
type Props = {
  listingId: string
  sellingPricesInCents: number
}
export const MortgageWidget: React.FC<Props> = ({ listingId, sellingPricesInCents }) => {
  const [show, setShow] = useState(false)
  const [useFallback, setUseFallback] = useState(false)
  const showRef = useRef<boolean>(show) /* This is necessary to avoid a race condition in readind show value */

  useEffect(() => {
    function handler(e: MessageEvent) {
      if (e.data === 'CASAVOMUTUI-WIDGET-LOADED') {
        setShow(true)
        showRef.current = true
      }
    }

    window.addEventListener('message', handler)

    return () => window.removeEventListener('message', handler)
  }, [])

  useEffect(() => {
    if (showRef.current) {
      return
    }

    const id = setTimeout(() => {
      if (!showRef.current) {
        setUseFallback(true)
      }
    }, 5000)
    return () => clearTimeout(id)
  }, [showRef])

  const url = `${process.env.NEXT_PUBLIC_CASAVO_MORTGAGES_WIDGET}/widget-simulazione?importoImmobile=${
    sellingPricesInCents / 100
  }&traffic_source=listing-detail&listingid=${listingId}&utm_source=listing-platform&utm_medium=widget-iframe&utm_campaign=trafficfromlistingDetail`

  if (useFallback) {
    /* TODO: Use an ad-hoc UI element similar to <MortgageBanner /> */
    return null /* In case of problems loading the widgets remove the occupied space */
  }

  return (
    <div className={show ? mortgageWidgetClass.visible : mortgageWidgetClass.hidden}>
      <iframe className={mortgageIframe} id="mutui-widget" src={url} title="mutui-widget" />
    </div>
  )
}
